export const SET_CURRENT_CONTEST = "SET_CURRENT_CONTEST";

export const setCurrentContest = (contestId: number) => ({
    type: SET_CURRENT_CONTEST,
    payload: { contestId }
});
